import React from 'react';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { Color } from '../../../app/models/Color';
import ColorForm from './forms/ColorForm';

interface Props {
    fetching?: boolean;
    action: () => void;
    cancel: () => void;
    color: Color;
    setColor: (color: Color) => void;
    errorFields?: any;
}

const ColorFormContainer = ({
    fetching,
    action,
    cancel,
    color,
    setColor,
    errorFields = null
}: Props) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <ColorForm
                        colorDataForm={color}
                        setColorDataForm={setColor}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={action} locked={fetching} />
                </div>
            </div>
        </>
    );
};

export default ColorFormContainer;
